"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationHeader = void 0;
var _useRecommendationStatus = require("./useRecommendationStatus");
var _services = require("../../services");
const useRecommendationHeader = () => {
  const {
    isJourneyForHandsetAndPlan,
    isJourneyForHandset,
    isJourneyForPlan,
    isJourneyForBroadband
  } = (0, _useRecommendationStatus.useRecommendationStatus)();
  let headerText, headerTitle, headerSubtitle;
  switch (true) {
    case isJourneyForHandsetAndPlan:
      headerText = _services.locale.localeString('Recommendation.HeaderPhoneAndPlan');
      headerTitle = _services.locale.localeString('Recommendation.HeaderPhoneAndPlanFullPage');
      headerSubtitle = _services.locale.localeString('Recommendation.HeaderPhoneAndPlanSubtitle');
      break;
    case isJourneyForHandset:
      headerText = _services.locale.localeString('Recommendation.HeaderPhone');
      headerTitle = _services.locale.localeString('Recommendation.HeaderPhoneFullPage');
      headerSubtitle = _services.locale.localeString('Recommendation.HeaderPhoneSubtitle');
      break;
    case isJourneyForPlan:
      headerText = _services.locale.localeString('Recommendation.HeaderPlan');
      headerTitle = _services.locale.localeString('Recommendation.HeaderPlanFullPage');
      headerSubtitle = _services.locale.localeString('Recommendation.HeaderPlanSubtitle');
      break;
    case isJourneyForBroadband:
      headerText = _services.locale.localeString('Recommendation.HeaderBroadband');
      headerTitle = _services.locale.localeString('Recommendation.HeaderBroadbandFullPage');
      headerSubtitle = _services.locale.localeString('Recommendation.HeaderBroadbandSubtitle');
  }
  return {
    headerTitle,
    headerText,
    headerSubtitle
  };
};
exports.useRecommendationHeader = useRecommendationHeader;